import DashboardPage from "../pages/dashboard/DashboardPage.vue"
import i18n from '../i18n';

const dashboardRoutes = [
    {
        path: `dashboard`,
        name: "Dashboard",
        component: DashboardPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Dashboard") }
                ]
            }
        }
    },
]

export default dashboardRoutes
